import PropTypes from 'prop-types'

const BordePrincipal = (props) => {
  return (
    <fieldset className="fieldset">
      <legend>{props.titulo}</legend>
      <div>{props.children}</div>
    </fieldset>
  )
}

BordePrincipal.propTypes = {
  titulo: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default BordePrincipal
